import React from 'react';
import { Link } from 'react-router-dom';
import useInstallPrompt from '../hooks/useInstallPrompt';

// Dismissible banner offering to install Previu to the home screen.
// Styling lives in index.css (.install-banner) so every portal shares it.
export default function InstallPrompt() {
  const { mode, install, dismiss } = useInstallPrompt();
  if (!mode) return null;

  return (
    <div className="install-banner" role="region" aria-label="Install Previu">
      <div className="install-banner-text">
        <strong>Install Previu</strong>
        <span>
          {mode === 'ios'
            ? 'Tap the Share button, then “Add to Home Screen”.'
            : 'Add it to your home screen for faster access.'}
        </span>
      </div>
      {mode === 'ios' && (
        <Link className="btn btn-primary btn-sm" to="/install">Show me how</Link>
      )}
      {mode === 'prompt' && (
        <button type="button" className="btn btn-primary btn-sm" onClick={install}>Install</button>
      )}
      <button type="button" className="btn btn-ghost btn-sm" onClick={dismiss}>Not now</button>
    </div>
  );
}
